<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">New user</h2>
  <p class="dialog-subtitle">Add a teammate to your company's account.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Full name</mat-label>
    <input matInput [(ngModel)]="form.fullName" name="fullName" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Email</mat-label>
    <input matInput type="email" [(ngModel)]="form.email" name="email" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Password</mat-label>
    <input matInput [type]="hidePassword() ? 'password' : 'text'" [(ngModel)]="form.password" name="password" />
    <button
      class="password-toggle"
      matSuffix
      type="button"
      (click)="hidePassword.set(!hidePassword())"
      [attr.aria-label]="hidePassword() ? 'Show password' : 'Hide password'"
    >
      <span class="material-icons">{{ hidePassword() ? 'visibility_off' : 'visibility' }}</span>
    </button>
    <mat-hint>At least 8 characters</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Role</mat-label>
    <mat-select [(ngModel)]="form.role" name="role">
      @for (role of roles; track role) {
        <mat-option [value]="role">{{ role }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Creating…' : 'Create user' }}
  </button>
</mat-dialog-actions>
